import { CdkDragDrop, CdkDragStart, CDK_DRAG_CONFIG, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppSettingService } from 'src/app/modules/shared/components/setting-modal/app.setting.service';
import { Status } from 'src/app/modules/shared/models/status';

const DragConfig = {
  dragStartThreshold: 0,
  pointerDirectionChangeThreshold: 5,
  zIndex: 99999
};

@Component({
  selector: 'app-manually-setting',
  templateUrl: './manually-setting.component.html',
  styleUrls: ['./manually-setting.component.scss'],
  providers: [{ provide: CDK_DRAG_CONFIG, useValue: DragConfig }]
})
export class ManuallySettingComponent implements OnInit{

  @Input() module;
  @Input() channel;
  @Input() display: boolean = false;
  @Input() columnSettingName: string = '';
  @Input() objectId: string = null;
  @Input() settingObj: object;
  @Input() columnSettingsConfig: any = null;
  @Input() allColumnSettings: any = [];

  @Output() cancelClicked = new EventEmitter();
  @Output() onUpdateSetting = new EventEmitter();
  @Output() onUpdateProcess = new EventEmitter();

  tempCols = [];
  maxNo = false;
  totalAmt = 0;

  currentChannelId: number = 0;
  currentTemplateId: number = 0;
  currentColumnSettingsConfig = null;
  currentAllColumnSettings = [];
  listSearchInput: string = '';
  tempColumnSettings = null;

  startDrag = false;
  showContent = true;
  showAccountEmailChild = false;
  showAccountPhoneChild = false;


  constructor(
    private cdr: ChangeDetectorRef,
    private appSettingService: AppSettingService,
    private app: AppMainComponent,

  ) { }

  ngOnInit(): void {
    this.listSearchInput = '';
    this.totalAmt = 0;
    this.tempColumnSettings = JSON.parse(JSON.stringify(this.settingObj));
    this.currentAllColumnSettings = JSON.parse(JSON.stringify(this.allColumnSettings));
    this.currentColumnSettingsConfig = JSON.parse(JSON.stringify(this.columnSettingsConfig));
    this.tempCols = this.tempColumnSettings.listCols != undefined ? this.tempColumnSettings.listCols : [];
    this.tempCols.map((col,index)=> {col['hideChilds']=(index>0)});

    for (let section of this.tempCols) {
        for (let col of section.fields) {
            if (col.fieldTypes && col.fieldTypes.fields) {
                col.showChildrens = col.fieldTypes.fields.find(field => field.ischecked == true);
                for (let childCol of col.fieldTypes.fields) {
                    if (childCol.ischecked == true) { this.totalAmt++; }
                }
            } else {
                if (col.ischecked == true) { this.totalAmt++; }
            }
        }
    }
    this.maxNo = this.totalAmt >= 7;
  }

  cancelSettings() {
    this.cancelClicked.emit({})
  }
  saveSettings() {
    if (this.tempColumnSettings.listCols != undefined) {
        this.tempColumnSettings.listCols = this.tempCols
    }
    this.updateSettings(this.tempColumnSettings);
  }
  updateSettings(updateSetting) {
    this.currentChannelId = this.channel.id;
    this.currentTemplateId = this.channel.id;

    const checkSettingExists = this.currentAllColumnSettings?.length ? this.currentAllColumnSettings.find(obj => obj.channelId == 
        this.currentChannelId && obj.templateId == this.currentTemplateId) : undefined;

    if (checkSettingExists) {
        const indexOfCurrentRecord = this.currentAllColumnSettings.indexOf(checkSettingExists);
        this.currentAllColumnSettings.splice(indexOfCurrentRecord, 1, updateSetting)
    } else {
        if (this.currentAllColumnSettings == null) {
            this.currentAllColumnSettings = [];
        }
        this.currentAllColumnSettings.push({ ...updateSetting, channelId: this.currentChannelId, templateId: this.currentTemplateId })
    }

    const foundDefault = this.currentAllColumnSettings.find(el => el.channelId === 0 && el.templateId === 0);

    if (!foundDefault) {
        this.currentAllColumnSettings.unshift({ ...updateSetting, channelId: 0, templateId: 0 });
    }

    const data = {
        "id": this.currentColumnSettingsConfig ? this.currentColumnSettingsConfig.id : 0,
        "createdSource": "Web",
        "updatedSource": "Web",
        "createdBy": this.app.user.userId,
        "updatedBy": this.app.user.userId,
        "createdDate": new Date().toISOString(),
        "updatedDate": new Date().toISOString(),
        "organizationId": this.app.user.organizationId,
        "name": this.columnSettingsConfig.name,
        "description": this.columnSettingsConfig.name,
        "configJSONSchema": "",
        "configJSONValue": JSON.stringify(this.currentAllColumnSettings),
        "objectId": this.objectId,
        "levelId": 4, // user level permission
        "levelRecordId": this.app.user.userId, // user permissions, here we pass user id
        "categoryId": 6,
        "statusId": Status.Active,
        "typeId": 105 // this is constant for column settings
    }

    this.onUpdateProcess.emit({ 'start': true });

    this.appSettingService.updateConfiguration(data)
        .then(() => {
            this.onUpdateProcess.emit({ 'start': false });
            this.onUpdateSetting.emit(updateSetting)
        }).catch(() => {
            this.onUpdateProcess.emit({ 'start': false });
        });
  }
  cdkDragStarted(event: CdkDragStart){
    this.startDrag = true;
    this.showContent = false;
  }
  dropListCol(event: CdkDragDrop<string[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  }
  cdkDragReleased(){
    this.startDrag = false;
    this.showContent = true;
  }
  toggleChilds(section){
    section['hideChilds'] = !section?.hideChilds;
  }
  dropCol(event: CdkDragDrop<string[]>) {
    if (event.currentIndex > 1)
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  }
  showChild(col) {
    col.fieldTypes.showChildrens = col.fieldTypes.showChildrens != undefined ? !col.fieldTypes.showChildrens : true;
    if (col.code == 'account email') {
        this.showAccountEmailChild = !this.showAccountEmailChild;
        this.showAccountPhoneChild = false;
    } else if (col.code == 'account phone') {
        this.showAccountPhoneChild = !this.showAccountPhoneChild;
        this.showAccountEmailChild = false;
    }
  }
  onChange(isChecked: boolean, col, childCol?) {
    if (childCol && col.fieldTypes && col.fieldTypes.fields) {
        if (isChecked) {
            if (this.totalAmt <= 7)
                this.totalAmt++;
            childCol.isColumnSetting = true;
        } else {
            this.totalAmt--;
            childCol.isColumnSetting = false;
        }
    } else {
        if (isChecked) {
            if (this.totalAmt <= 7)
                this.totalAmt++;
            col.isColumnSetting = true;
        } else {
            this.totalAmt--;
            col.isColumnSetting = false;
        }
    }
    this.maxNo = this.totalAmt >= 7;
  }

}
